/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { archivedListConfig } from '../../config/archivedLists.config';
export interface IArchivedListPluginMethods extends IPluginMethodMap {
  getArchivedListSync(args?: any): any;
}

export class ArchivedListPlugin implements IAgentPlugin {
  readonly methods: IArchivedListPluginMethods;

  constructor() {
    this.methods = {
      getArchivedListSync: this.getArchivedListSync.bind(this),
    };
  }

  async getArchivedListSync(args?: any) {
    await new Promise((r) => setTimeout(r, 2000));
    return {
      ArchivedList: archivedListConfig,
    };
  }
}
